import styled from "styled-components";

const DashboardWelcomeSVGContainer = styled.div`
    text-align: center;
    width: 100%;
`;

export const DashboardWelcomeArt = () => (
    <DashboardWelcomeSVGContainer>
        <svg
            width="502"
            height="328"
            viewBox="0 0 502 328"
        >
            <defs>
                <linearGradient
                    id="a"
                    x1="56.362%"
                    x2="56.362%"
                    y1="100%"
                    y2="32.98%"
                >
                    <stop
                        offset="0%"
                        stopColor="#CAE4FE"
                    ></stop>
                    <stop
                        offset="100%"
                        stopColor="#E9F3FB"
                    ></stop>
                </linearGradient>
                <path
                    id="c"
                    d="M425.024 185.088c3.587-5.47 20.317-21.437 20.513-21.233 1.102 1.148 18.704 19.01 21.329 22.018l-41.842-.785z"
                ></path>
                <filter
                    id="b"
                    width="133.5%"
                    height="163.6%"
                    x="-16.7%"
                    y="-22.7%"
                    filterUnits="objectBoundingBox"
                >
                    <feOffset
                        dy="2"
                        in="SourceAlpha"
                        result="shadowOffsetOuter1"
                    ></feOffset>
                    <feGaussianBlur
                        in="shadowOffsetOuter1"
                        result="shadowBlurOuter1"
                        stdDeviation="2"
                    ></feGaussianBlur>
                    <feColorMatrix
                        in="shadowBlurOuter1"
                        values="0 0 0 0 0.873291758 0 0 0 0 0.886378124 0 0 0 0 0.901333971 0 0 0 0.6 0"
                    ></feColorMatrix>
                </filter>
                <path
                    id="e"
                    d="M330.276 1.17c-8.888-2.612-17.405-.94-23.82 5.914-19.033 20.338 1.381 52.783 27.43 41.65 9.384-4.012 14.81-18.68 13.233-28.795-1.265-8.112-8.57-18.512-16.843-18.512"
                ></path>
                <filter
                    id="d"
                    width="153.7%"
                    height="151%"
                    x="-26.9%"
                    y="-21.6%"
                    filterUnits="objectBoundingBox"
                >
                    <feOffset
                        dy="2"
                        in="SourceAlpha"
                        result="shadowOffsetOuter1"
                    ></feOffset>
                    <feGaussianBlur
                        in="shadowOffsetOuter1"
                        result="shadowBlurOuter1"
                        stdDeviation="4"
                    ></feGaussianBlur>
                    <feColorMatrix
                        in="shadowBlurOuter1"
                        values="0 0 0 0 0.873291758 0 0 0 0 0.886378124 0 0 0 0 0.901333971 0 0 0 0.6 0"
                    ></feColorMatrix>
                </filter>
                <path
                    id="g"
                    d="M354.305 270.19c-.066 26.772.154 45.465-.127 45.465-10.164 0 48.768.032 49.072-.554 1.34-2.585 1.742-43.191.22-45.263-1.522-2.072-49.165.352-49.165.352z"
                ></path>
                <filter
                    id="f"
                    width="127.2%"
                    height="130%"
                    x="-13.6%"
                    y="-10.7%"
                    filterUnits="objectBoundingBox"
                >
                    <feOffset
                        dy="2"
                        in="SourceAlpha"
                        result="shadowOffsetOuter1"
                    ></feOffset>
                    <feGaussianBlur
                        in="shadowOffsetOuter1"
                        result="shadowBlurOuter1"
                        stdDeviation="2"
                    ></feGaussianBlur>
                    <feColorMatrix
                        in="shadowBlurOuter1"
                        values="0 0 0 0 0.873291758 0 0 0 0 0.886378124 0 0 0 0 0.901333971 0 0 0 0.6 0"
                    ></feColorMatrix>
                </filter>
            </defs>
            <g
                fill="none"
                fillRule="evenodd"
            >
                <path
                    fill="#B1D8FF"
                    d="M92.7 96.73c.045 16.426-.106 27.895.087 27.895 6.96 0-33.401.02-33.61-.34-.918-1.586-1.193-26.5-.15-27.771 1.042-1.271 33.673.216 33.673.216z"
                ></path>
                <path
                    fill="#FFF"
                    stroke="#B1D8FF"
                    strokeWidth="2"
                    d="M83.808 30.28c0-3.327 347.265-3.24 352.463 2.738 5.2 5.979-1.159 233.933-4.724 243.608-3.564 9.674-340.207 6.456-343.753 6.456-3.545 0-3.986-249.475-3.986-252.802z"
                ></path>
                <path
                    fill="url(#a)"
                    d="M412.912 149.265c-.095 57.87-.304 94.529-2.843 96.553-57.621 3.763-266.498.273-266.491-.633.04-5.076-.51-87.115-.426-97.846l269.76 1.926z"
                    transform="translate(0 6)"
                ></path>
                <path
                    stroke="#F5F9FD"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.98"
                    d="M241.072 90.545c.133 28.919.162 47.238-.774 48.26-21.377 2.104-96.655.724-98.915.724-.862 0-.442-43.53-.442-48.893l100.131-.09z"
                ></path>
                <path
                    fill="#CFE6FD"
                    d="M100.527 167.055c.134 46.667 1.116 79.812 1.682 79.866 20.768 1.991-73.133 4.184-97.987 0-1.485-.25-3.534-76.677-2.238-79.866 1.297-3.19 98.543 0 98.543 0z"
                ></path>
                <path
                    stroke="#B1D8FF"
                    strokeDasharray="5.94000023365021,3.959999980926511"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M413.007 88.127c.205 30.329.249 49.541-1.193 50.613-32.93 2.207-152.374 1.234-152.374.76 0-2.661-.682-45.654-.682-51.278l154.249-.095z"
                ></path>
                <path
                    fill="#1B2653"
                    d="M121.344 27.684c1.169.628 0 256.771 0 256.771-10.174-.073-35.926 1.262-35.97 0-4.284-120.905-3.72-255.904-3.046-255.904.675 0 37.847-1.495 39.016-.867z"
                ></path>
                <path
                    fill="#CAE4FE"
                    d="M346.58 108.831c-1.255-4.081-5.463-6.282-9.267-7.368-11.288-3.224-21.427 11.13-13.478 20.21 9.625 10.997 25.741 4.047 22.815-12.42"
                ></path>
                <g
                    stroke="#FFF"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.98"
                >
                    <path d="M327 113.718c4.55-.237 9.36-.098 13.874-.777M334 108c.384 3.889.77 7.756.77 11.657"></path>
                </g>
                <path
                    stroke="#FFF"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.98"
                    d="M170.67 206.601c5.65-6.75 12.022-10.064 19.815-11.01 20.137-2.444 37.909 16.393 58.49 13.618 19.57-2.64 33.92-27.666 54.67-23.469 26.682 5.397 42.577 33.27 71.62 15.646 3.993-2.423 8.314-5.038 11.22-9.272"
                ></path>
                <path
                    stroke="#FFF"
                    strokeDasharray="5.94000023365021,3.959999980926511"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.98"
                    d="M172.873 172.161c8.893-1.352 14.836 10.562 21.765 17.704 20.563 21.192 23.845 27.19 49.784 32.824 7.9 1.716 16.338 2.97 24.313 1.476 17.221-3.227 26.954-17.486 44.596-14.676 5.92.943 17.386 4.808 23.017 7.3 13.819 6.114 29.253 8.113 43.531 8.113"
                ></path>
                <path
                    stroke="#B1D8FF"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.98"
                    d="M160.453 75c37.489.236 66.94 0 113.032 0"
                ></path>
                <path
                    stroke="#4F8EF9"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.98"
                    d="M97 130c4.026.414 8.579 0 12.621 0M97 98c4.026.414 8.07.378 12.112.378M98 141.254c4.01.65 8.161-.65 12.112-.126"
                ></path>
                <path
                    stroke="#FF8100"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="3"
                    d="M97 107.72c4.002 0 7.723.139 12.112.139"
                ></path>
                <path
                    stroke="#4F8EF9"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.98"
                    d="M98 150.63c3.693-.028 7.317-.63 11.011-.63M98 118.63c3.693-.028 7.317-.63 11.011-.63"
                ></path>
                <path
                    fill="#FFF"
                    d="M102.578 44.784c1.298 2.173 5.093 1.733 3.962 7.363-.169.84-.77 2.057-1.257 2.608-1.229 1.39 4.493-1.09 5.737-3.674 2.243-4.66-1.962-9.921-4.113-10.477-3.359-.868-5.647 1.973-4.329 4.18z"
                ></path>
                <path
                    fill="#FFF"
                    d="M104.401 50.39c-1.23-2.228-5.113-2.004-3.725-7.525.207-.823.87-1.997 1.39-2.516 1.31-1.31-4.621.83-5.996 3.323-2.48 4.496 1.582 9.95 3.748 10.621 3.384 1.049 5.833-1.64 4.583-3.903z"
                ></path>
                <path
                    stroke="#B1D8FF"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.98"
                    d="M162.963 172.055c2.076 55.857.576 64.618 1.886 66.008 147.999 2.808 188.542 2.238 221.637 2.14"
                ></path>
                <path
                    fill="#FF8700"
                    d="M368.868 310.372c12.381-12.016 9.502-13.45 19.82.407"
                ></path>
                <path
                    fill="#FF8100"
                    d="M140.28 118.127c-1.333-6.25-.387-29.999-.105-30 1.583-.005 26.505.834 30.468 1.008l-30.364 28.992zM0 259.349c3.587-5.47 20.317-21.438 20.513-21.233 1.102 1.147 18.704 19.01 21.329 22.018L0 259.349z"
                ></path>
                <g transform="translate(0 6)">
                    <use
                        fill="#000"
                        filter="url(#b)"
                        xlinkHref="#c"
                    ></use>
                    <use
                        fill="#1B2653"
                        xlinkHref="#c"
                    ></use>
                </g>
                <path
                    stroke="#F5F9FD"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.98"
                    d="M189.389 91.922c1.07 15.947-.781 32.241.725 48.205"
                ></path>
                <path
                    stroke="#B1D8FF"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.98"
                    d="M7.765 274.744c-.735 2.157-1.457 4.25-1.684 6.498-1.757 17.44 25.647 4.786 16.092-3.342-5.13-4.364-8.602 9.24 4.303 12.44 6.85 1.7 14.472-9.53 7.11-13.183-5.23-2.595-5.234 9.527 2.058 11.698 17.42 5.187 20.56-18.04 11.601-14.483-6.653 2.641-.784 15.902 8.233 14.112 4.085-.81 13.448-12.307 6.175-14.112-3.21-.796-3.743 3.705-3.743 5.942 0 6.12 6.541 5.833 10.853 7.056"
                ></path>
                <g transform="translate(0 6)">
                    <use
                        fill="#000"
                        filter="url(#d)"
                        xlinkHref="#e"
                    ></use>
                    <use
                        fill="#FFC100"
                        xlinkHref="#e"
                    ></use>
                </g>
                <path
                    fill="#FF8100"
                    d="M448.055 100.932c-2.52-1.94-7.514-3.489-11.487-1.605-11.79 5.59-8.214 23.48 5.128 23.18 4.806-.107 9.65-5.606 10.645-10.337.799-3.794-1.765-9.298-4.286-11.238z"
                ></path>
                <path
                    fill="#FFC100"
                    d="M90.156 304.316c-3.264-.795-6.35-.115-8.618 2.33-6.73 7.254 1.03 18.214 10.407 14.055 3.379-1.499 5.21-6.63 4.533-10.106-.541-2.786-3.306-6.29-6.32-6.19"
                ></path>
                <path
                    stroke="#B1D8FF"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.98"
                    d="M453.653 97.189C467.419 81.954 486.15 72.296 501 58.655M460.26 100.492c5.145-4.742 10.167-9.746 15.415-14.313M449.248 92.785c2.723-2.82 5.145-5.852 7.708-8.808M28.629 133.521c5.208-.855 10.176-2.202 15.415-2.202M36.336 125.814c.926 5.063.457 10.337 1.101 15.414M163 297c4.94 5.367 10.203 10.341 15.415 15.414M176.112 296c-3.35 5.435-8.164 9.488-12.112 14.313"
                ></path>
                <g transform="translate(0 6)">
                    <use
                        fill="#000"
                        filter="url(#f)"
                        xlinkHref="#g"
                    ></use>
                    <use
                        fill="#FF8100"
                        xlinkHref="#g"
                    ></use>
                </g>
                <path
                    fill="#4F8DF9"
                    d="M102.269 63h28.835a7.216 7.216 0 0 1 7.21 7.5 7.807 7.807 0 0 1-7.8 7.5h-29.656a6.858 6.858 0 0 1-6.828-7.5 8.275 8.275 0 0 1 8.239-7.5zM395.643 224c-1.292 19.85-1.978 79.194-1.48 79.257 14.606 1.842 87.783-.233 87.783-.958 0-4.063 2.082-65.558.394-78.299h-86.697z"
                ></path>
                <path
                    stroke="#FFF"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2.2"
                    d="M412 239v41h50"
                ></path>
                <path
                    stroke="#FFF"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2.2"
                    d="M421 258h8v22h-8zM434 253h8v27h-8zM448 244h8v36h-8zM420 286h8M434 286h8M449 286h8"
                ></path>
                <path
                    stroke="#CFE6FD"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2.2"
                    d="M466 234h8M466 238h8M466 242h8"
                ></path>
                <g transform="translate(19 181)">
                    <circle
                        cx="27.5"
                        cy="27.5"
                        r="27.5"
                        fill="#4F8DF9"
                        transform="rotate(-90 27.5 27.5)"
                    ></circle>
                    <path
                        fill="#1B2653"
                        d="M28 0c14.793.264 26.736 12.207 27 27H28V0z"
                    ></path>
                    <path
                        fill="#FFF"
                        d="M46 7.334L28 27V0c6.947.125 13.259 2.885 18 7.334z"
                    ></path>
                </g>
                <path
                    stroke="#B1D8FF"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.98"
                    d="M158 64.522c2.985-2.21 5.589-4.787 7.812-7.43 5.097-6.061 1.983-19.006-3.906-10.837-5.862 8.132 2.7 21.84 15.625 16.719 5.662-2.244 20.95-15.86 7.421-17.648-7.821-1.033-7.003 16.07.391 18.267 12.524 3.723 32.758-10.879 21.093-20.125-6.25-4.954-12.263 15.853 1.563 19.506 14.82 3.915 36.974-12.31 23.827-20.125-8.029-4.773-8.499 12.009-6.25 14.861 13.88 17.603 37.644-9.23 28.906-12.694-6.666-2.642-7.935 7.66-7.031 10.527 2.878 9.124 24.512 6.502 33.593 6.502"
                ></path>
                <g>
                    <path
                        fill="#D56C00"
                        d="M371 298.285c1.372 1.987 7.769 7.789 7.844 7.714.421-.417 7.152-6.906 8.156-7.999l-16 .285z"
                    ></path>
                    <path
                        fill="#D56C00"
                        fillRule="nonzero"
                        d="M376 289h6v11h-6z"
                    ></path>
                    <path
                        stroke="#D56C00"
                        strokeWidth="4"
                        d="M370 310h18"
                    ></path>
                </g>
            </g>
        </svg>
    </DashboardWelcomeSVGContainer>
);
